export default __webpack_public_path__ + "static/media/icon-Hub-Analytics.5e8ca57d.svg";